<template>
  <div class="full-h-view d-flex flex-column justify-content-between h-100">
    <div
      class="nav-header d-flex justify-content-between align-items-center py-1 ps-3 pe-1"
    >
      <h1 class="add_on-pending-title">{{ t("ADD_ONS.PENDING.HEADER") }}</h1>
      <span
        class="material-symbols-outlined p-2_5 close-view"
        @click="handleClose"
        >close</span
      >
    </div>
    <div class="content-container">
      <div
        class="mx-4 d-flex flex-grow-1 flex-column justify-content-center align-items-center text-center"
      >
        <div class="flex-grow-1"></div>
        <div class="pending-icon-wrapper mb-3">
          <span class="material-symbols-outlined pending-icon">alarm</span>
        </div>
        <div class="notif-msg mb-2">
          {{ t("ADD_ONS.PENDING.SUBTITLE", { addOnName: addOnDetails?.addOnName || "" }) }}
        </div>
        <div class="notif-content mb-2">
          {{ t("ADD_ONS.PENDING.REQUEST_IN_PROGRESS") }}
        </div>
        <div class="notif-content-bold mb-2">
          {{ t("ADD_ONS.PENDING.ESTIMATED_TIME") }}
        </div>
        <br>
        <div class="notif-content mb-4">
          {{ t("ADD_ONS.PENDING.NO_CHARGE_GUARANTEE") }}
        </div>
        <div class="flex-grow-1"></div>
      </div>
    </div>
    <div class="mx-3 my-2_5 add_on-cta-btn-container">
      <Button type="primary" @click="handleClose">
        {{ t("ADD_ONS.PENDING.ACCEPT_AND_CLOSE_BTN") }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import Button from "@/apps/credit-line/components/Button.vue";
import type { IAddOnDetailsResponse } from "@/apps/credit-line/types/responses";

interface Props {
  addOnDetails: IAddOnDetailsResponse | null;
  onClose: () => void;
}

const props = defineProps<Props>();
const { t } = useI18n();

onMounted(() => {
  logAnalyticsEvent(
    AnalyticEvents.CreditLine.AddOnPendingPageDisplayed,
    "AddOns",
    undefined,
    {
      cartAddOnId: props.addOnDetails?.cartAddOnId,
      addOnName: props.addOnDetails?.addOnName,
    }
  );
});

const handleClose = () => {
  logAnalyticsEvent(
    AnalyticEvents.CreditLine.AddOnPendingCloseClicked,
    "AddOns"
  );
  props.onClose();
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_spacing-utils.scss";

.full-h-view {
  min-height: 100dvh;
}
.nav-header {
  border-bottom: 1px solid #eee;
}
.add_on-pending-title {
  font-size: 1rem;
  font-weight: 500;
  font-family: Inter;
  line-height: 1.5rem;
  margin-bottom: 0;
  color: #111;
}
.close-view {
  color: #1c1b1f;
}
.pending-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #fff1c2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pending-icon {
  font-size: 32px;
  color: #d4a01b;
}
.notif-msg {
  font-size: 20px;
  line-height: 29px;
  font-weight: 600;
  font-family: Inter;
}
.notif-content {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  font-family: Inter;
  color: #595a5a;
}
.notif-content-bold {
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  font-family: Inter;
  color: #111;
}
.content-container {
  position: fixed;
  top: 3.5rem;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
}
.add_on-cta-btn-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
